export default "__VITE_ASSET__CeEZ1q$h__"